import "bootstrap/dist/css/bootstrap.min.css";
import "react-toastify/dist/ReactToastify.min.css";
import "react-day-picker/lib/style.css";
import Routes from "./routes/routes";
import { ToastContainer } from "react-toastify";

import { GlobalStyles } from "./style/global";
import { ModalProvider } from "./context/modal";
import { SectorProvider } from "./context/sectorFilter";
import { NumberMonitorProvider } from "./context/numberMonitorData";
import { NumberOfficialMonitorProvider } from "./context/numberOfficialMonitorData";

function App() {
  return (
    <>
      <ToastContainer />
      <GlobalStyles />
      <NumberMonitorProvider>
        <NumberOfficialMonitorProvider>
          <SectorProvider>
            <ModalProvider>
              <Routes />
            </ModalProvider>
          </SectorProvider>
        </NumberOfficialMonitorProvider>
      </NumberMonitorProvider>
    </>
  );
}

export default App;
